module.exports = "https://cdn.hellotech.com/client-assets/tv_large_c6268b57df69acea4170c1eb0f10c80d.png";